import { subCancelFlowSchema } from "../../../lib";
import { useRequestQuery } from "../../../request";
import { keyCancelFlow } from "./keySubscriptions";

export const useRequestCancelOptions = () => ({
  query: useRequestQuery({
    queryFnRequestProps: {
      schema: subCancelFlowSchema,
      urlBackendPath: "/subscription/cancel-flows",
    },
    queryKey: keyCancelFlow(),
  }),
});
